import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { FaBars } from "react-icons/fa";
import { db } from "./Firebase";
import { BiDownload } from "react-icons/bi";
import { FaDownload } from "react-icons/fa6";

export default function Enquiries() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);

    function onToggleSidebar() {
        setSidebarOpen(!sidebarOpen);
    }

    const [data, setdata] = useState([]);

    // function fetchdata() {
    //     db.collection("mainform").onSnapshot((succ) => {
    //         setdata(succ.docs)
    //     })
    // }

    function fetchdata() {
        db.collection("mainform").onSnapshot((succ) => {
            const sortedData = succ.docs.sort((a, b) => {
                const dateA = new Date(a.data().Date);
                const dateB = new Date(b.data().Date);

                return dateB - dateA; // Latest date first
            });

            setdata(sortedData);
        });
    }

    useEffect(() => {
        fetchdata();
    }, [])

    return (
        <>
            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    {/* Main Content */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 offset-0 offset-lg-0 offset-md-0 ps-5 helooo">

                        <div className="container-fluid mx-2">
                            {/* <div className="card shadow-sm border-0 "> */}
                            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 mx-3">
                                {/* <div className="d-flex justify-content-start"> */}
                                {/* <input type="text" placeholder="Search enquiries" className="me-3 form-control" /> */}
                                <select className="me-3 form-select w-25">
                                    <option>All Status</option>
                                    <option>Pending</option>
                                    <option>Contacted</option>
                                    <option>Converted</option>
                                    <option>Rejected</option>
                                </select>
                                {/* </div> */}
                                <button className="btn btn-primary">
                                    Enquiries
                                </button>
                            </div>
                            <div className="card shadow-sm mx-3">
                                <div className="card-body container-fluid px-0">
                                    <div className="table-responsive-sm table-responsive-md" style={{ maxHeight: "500px", overflowY: "auto" }}>
                                        <table className="table table-hover align-middle text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>NAME</th>
                                                    <th>BUSINESS</th>
                                                    <th>ENQUIRY TYPE</th>
                                                    <th>CONTACT</th>
                                                    <th>LOCATION</th>
                                                    <th>MESSAGE</th>
                                                    <th>DATE</th>
                                                    <th>STATUS</th>
                                                    <th>ACTIONS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((row, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td><strong>{row.data().Name}</strong></td>
                                                            <td>
                                                                {row.data().Businessname}
                                                                <br />
                                                                <small className="text-muted">{row.data().Businesstype}</small>
                                                            </td>
                                                            <td>{row.data().Enquirytype}</td>
                                                            <td>
                                                                {row.data().Email}
                                                                <br />
                                                                <small className="text-muted">{row.data().Number}</small>
                                                            </td>
                                                            <td>{row.data().Citystate}</td>
                                                            <td>
                                                                {row.data().Message
                                                                    ? row.data().Message.length > 10
                                                                        ? row.data().Message.slice(0, 10) + "..."
                                                                        : row.data().Message
                                                                    : ""}
                                                            </td>

                                                            <td>{row.data().Date}</td>
                                                            <td>
                                                                <select className={`form-select w-75 ${row.data().Status === "Pending"
                                                                    ? "bg-info text-light"
                                                                    : row.data().Status === "Contacted"
                                                                        ? "bg-primary text-light"
                                                                        : row.data().Status === "Converted"
                                                                            ? "bg-success text-light"
                                                                            : row.data().Status === "Rejected"
                                                                                ? "bg-danger text-light"
                                                                                : "bg-secondary"
                                                                    }`}
                                                                    value={row.data().Status}
                                                                    onChange={(e) =>
                                                                        db.collection("mainform").doc(row.id).update({
                                                                            Status: e.target.value,
                                                                        })
                                                                    }>
                                                                    <option value="Pending">Pending</option>
                                                                    <option value="Contacted">Contacted</option>
                                                                    <option value="Converted">Converted</option>
                                                                    <option value="Rejected">Rejected</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <button className="btn btn-link p-0 text-primary me-2" data-bs-toggle="modal" data-bs-target="#mymod" onClick={() => setSelectedEnquiry(row)}>
                                                                    View
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </div>
            <div className="modal fade" id="mymod" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Enquiry Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            {selectedEnquiry && (
                                <>
                                    <div className="row">
                                        <div className="col-lg-6 col-12">
                                            <p><strong>Name:</strong> {selectedEnquiry.data().Name}</p>
                                            <p><strong>Email:</strong> {selectedEnquiry.data().Email}</p>
                                            <p><strong>Location:</strong> {selectedEnquiry.data().Citystate}</p>
                                            <p><strong>Status:</strong> {selectedEnquiry.data().Status}</p>
                                        </div>
                                        <div className="col-lg-6 col-12">
                                            <p><strong>Business Name:</strong> {selectedEnquiry.data().Businessname}</p>
                                            <p><strong>Business Type:</strong> {selectedEnquiry.data().Businesstype}</p>
                                            <p><strong>Phone:</strong> {selectedEnquiry.data().Number}</p>
                                            <p><strong>Date:</strong> {selectedEnquiry.data().Date}</p>
                                        </div>
                                    </div>
                                    <p><strong>Message:</strong> {selectedEnquiry.data().Message}</p>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}